import { useComponent } from "@/hooks/useMicrositeComponent";
import { IMicrositeComponent, MComponentMapsProps } from "@/types/microsite";
import { cn } from "@/lib/utils";
import { Fragment, useEffect, useState } from "react";
import { SpoilerButton } from "./Spoiler";

const MapsComponent = {
  kind: "MAPS",
  Render: ({
    microsite,
    isBuilder,
    id,
    isFocus,
    data: {
      isSpoiler,
      spoilerButtonFont,
      spoilerButtonColor,
      spoilerButtonIcon,
      spoilerButtonText,
      spoilerButtonTextPosition,
      needPassword,
      passwordMessage,
      name: _name,
      address: _address,
      useLatLng: _useLatLng,
      lat: _lat,
      lng: _lng,
    },
  }) => {
    const [{ name, address, useLatLng, lat, lng }, setData] = useState({
      name: _name,
      address: _address,
      useLatLng: _useLatLng,
      lat: _lat,
      lng: _lng,
    });

    const { focusTo } = useComponent();

    const [isOpen, setIsOpen] = useState(false);

    const onProtectedOpen = (data) => {
      setData({
        name: data.name,
        address: data.address,
        useLatLng: data.useLatLng,
        lat: data.lat,
        lng: data.lng,
      });
    };

    useEffect(() => {
      setData({
        name: _name,
        address: _address,
        useLatLng: _useLatLng,
        lat: _lat,
        lng: _lng,
      });
    }, [_name, _address, _useLatLng, _lat, _lng]);

    if (name || address || (useLatLng && lat && lng)) {
      return (
        <SpoilerButton
          spoilerButtonFont={spoilerButtonFont}
          microsite={microsite}
          spoilerButtonColor={spoilerButtonColor}
          spoilerButtonIcon={spoilerButtonIcon}
          spoilerButtonText={spoilerButtonText}
          spoilerButtonTextPosition={spoilerButtonTextPosition}
          isOpen={isOpen}
          onToggle={() => setIsOpen(!isOpen)}
          isBuilder={isBuilder}
          isSpoiler={isSpoiler}
          id={id}
          needPassword={needPassword}
          onProtectedOpen={onProtectedOpen}
          passwordMessage={passwordMessage}
          isFocus={isFocus}
        >
          <div
            className={cn(
              "relative rounded-md w-full overflow-hidden",
              isSpoiler ? "" : "m-2"
            )}
            id={isBuilder ? `mcomp-${id}` : undefined}
          >
            {isBuilder && (
              <div
                className="absolute inset-0 bg-transparent"
                onClick={() => {
                  focusTo(id as string);
                }}
              />
            )}
            <iframe
              style={{ width: "100%", height: 300 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={
                "https://www.google.com/maps/embed/v1/place?" +
                new URLSearchParams({
                  key: "AIzaSyC-r8Xs2N2IMwr-gLYHCktapalCBhA9VP0",
                  q: !useLatLng ? [name, address].join(" ") : lat + "," + lng,
                })
              }
            ></iframe>
          </div>
        </SpoilerButton>
      );
    }
    return <Fragment />;
  },
} as IMicrositeComponent<MComponentMapsProps>;

export default MapsComponent;
